import type { ComponentType } from 'react'
import type { ModuleId, ModuleDataMap } from '@/types/task'
import { DriveInputComponent } from '@/components/modules/drive-input'
import { VaultInputComponent } from '@/components/modules/vault-input'
import { MetricInputComponent } from '@/components/modules/metric-input'
import { BranchInputComponent } from '@/components/modules/branch-input'

// Props standar yang diterima oleh setiap module component
export interface ModuleComponentProps<K extends ModuleId = ModuleId> {
  moduleId: K
  value: ModuleDataMap[K]                     // undefined jika belum pernah diisi
  onChange: (data: ModuleDataMap[K]) => void   // dipanggil setiap perubahan nilai
  readOnly?: boolean                           // true = tampilan view mode (detail page)
}

// Metadata modul untuk ditampilkan di settings UI (Phase 9)
export interface ModuleDefinition {
  id: ModuleId
  label: string       // nama yang ditampilkan ke user
  description: string // deskripsi singkat untuk settings UI
  icon: string        // emoji untuk label visual
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  component: ComponentType<any>
}

// Registry — satu-satunya sumber kebenaran modul yang tersedia di aplikasi
export const MODULE_REGISTRY: Record<ModuleId, ModuleDefinition> = {
  drive: {
    id: 'drive',
    label: 'Drive / Asset',
    description: 'Lampirkan link ke Google Drive, GitHub, Figma, atau aset lain.',
    icon: '📎',
    component: DriveInputComponent,
  },
  vault: {
    id: 'vault',
    label: 'Vault / ENV',
    description: 'Simpan nilai sensitif seperti env variable atau credential.',
    icon: '🔒',
    component: VaultInputComponent,
  },
  metric: {
    id: 'metric',
    label: 'Metric / Tracker',
    description: 'Lacak nilai numerik seperti progress persentase atau hitungan.',
    icon: '📊',
    component: MetricInputComponent,
  },
  branch: {
    id: 'branch',
    label: 'Branch Tracker',
    description: 'Track branch per repo — dari branch apa dibuat dan udah sampai stage mana.',
    icon: '🌿',
    component: BranchInputComponent,
  },
}

// Helper: kembalikan ordered list modul dari array ID
// Urutan output mengikuti urutan input (urutan aktivasi di project settings)
export function getActiveModuleDefinitions(activeModules: ModuleId[]): ModuleDefinition[] {
  return activeModules.map((id) => MODULE_REGISTRY[id]).filter(Boolean)
}
